import React, { useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getFeedbacks, deleteFeedback } from "../../../api/feedback";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button } from "reactstrap";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";

export default function FeedbackList() {
  const navigate = useNavigate();
  const { dealId } = useParams();

  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || "";
  const hasPermission = (action) => {
    if (role.name === "super admin") return true;
    return (
      role.permissions &&
      role.permissions.some(
        (perm) => perm.resource === "Sales" && perm.actions.includes(action)
      )
    );
  };
  const canEdit = () => hasPermission("update");
  const canDelete = () => hasPermission("delete");
  const canRead = () => hasPermission("read");
  const {
    response,
    loading,
    error,
    setPage,
    page,
    setMeta,
    totalPages,
  } = usePagination(
    getFeedbacks,
    dealId ? { dealId } : null,
    Boolean(dealId)
  );

  const [filters, setFilters] = useState({
    clientSatisfaction: "",
  });

  function handleFilter() {
    setMeta((m) => ({
      ...m,
      page: 1,
      payload: {
        ...filters,
        ...(dealId ? { dealId } : {}),
      },
    }));
  }

  const handleDelete = async (id) => {
    if (window.confirm(t("Are you sure you want to delete this feedback?"))) {
      try {
        await deleteFeedback(id);
        setPage(1);
      } catch (error) {
        console.error("Delete failed:", error);
        alert(t("Failed to delete feedback."));
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={`${t("List")} ${t("Feedbacks")}`}
          // addUrl={`/feedback/add/${dealId}`}
          // hasAddBtn={canEdit()}
        />
        {canRead() || canDelete() || canEdit() ? (
          response && response.length > 0 && !loading ? (
            <CustomTable
              emptyMsg={t("No Feedback Found.")}
              data={response}
              loading={loading}
              error={error}
              cols={[
                {
                  label: t("Client Satisfaction"),
                  key: "clientSatisfaction",
                  style: { width: "25%" },
                },
                {
                  label: t("Campaign Delivered"),
                  key: "campaignDelivered",
                  style: { width: "15%" },
                  renderer: (row) => (row.campaignDelivered ? t("Yes") : t("No")),
                },
                {
                  label: t("Upsell Potential"),
                  key: "upsellPotential",
                  style: { width: "15%" },
                  renderer: (row) => (row.upsellPotential ? t("Yes") : t("No")),
                },
                {
                  label: t("Notes"),
                  key: "notes",
                  style: { width: "30%" },
                },
                {
                  label: t("Actions"),
                  key: "actions",
                  style: { width: "15%" },
                  renderer: (row) => (
                    <div className="d-flex gap-2">
                      {canEdit() && (
                        <Button
                          color="info"
                          size="sm"
                          onClick={() =>
                            navigate(

                              `/feedback/edit/${row._id}/`

                            )
                          }
                        >
                          {t("Edit")}
                        </Button>
                      )}
                      {canDelete() && (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDelete(row._id)}
                        >
                          {t("Delete")}
                        </Button>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            !loading && <div>{t("No results found.")}</div>
          )
        ) : (
          <div>{t("You do not have permission to view this list.")}</div>
        )}

        {response && !loading && canRead() && (
          <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
        )}
      </div>
    </div>
  );
}
